export default __webpack_public_path__ + "static/media/l42.bdfc4797.png";